import styles from './pageHeader.module.css';
import useIsMobile from '../../hooks/useIsMobile';
import PageHeaderLoader from './pageHeaderLoader';
import {Typography, Marker} from '@toppy-webshop/toppy-design-system';
import React from 'react';
import {useI18nContext} from '../../i18n/i18n-react';
import {useOrderStore} from '../../store/orderStore';

const PageHeader = () => {
    const {LL} = useI18nContext();
    const {isMobile} = useIsMobile(576);
    const order = useOrderStore(state => state.order);

    return (
        <header className={styles.header}>
            <div className={styles.title}>
                <Typography variant={isMobile ? 'h3' : 'h2'}>
                    Alles over je bestelling,{' '}
                    <Marker variant={'marker1'}>Zo Geregeld</Marker>
                </Typography>
            </div>
            {order ? (
                <span className={styles.wrapper}>
                    <span className={styles.label}>
                        {!isMobile && (
                            <Typography size={'s'} weight={'bold'}>
                                {LL.order.number()}
                                {': '}
                            </Typography>
                        )}
                        <Typography size={'s'} weight={'bold'}>
                            {order.orderNumber}
                        </Typography>
                    </span>
                </span>
            ) : (
                <PageHeaderLoader style={{width: '100%'}} />
            )}
        </header>
    );
};

export default PageHeader;
